(function (module) {
    'use strict';

    module.directive('compareTo',()=> {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ctrl) {

                ctrl.$validators.compareTo = (val)=> {
                    return val == scope.$eval(attrs.compareTo);
                };

                scope.$watch(attrs.compareTo, ()=> {
                    ctrl.$validate();
                });
            }
        };
    });


})(angular.module('rocket.components'));
